import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  // Navigate,
} from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

import ProtectedRoute from "./ProtectRoutes/ProtectedRoute";

import Topbar from "./Components/Topbar/Topbar";
import Navbar from "./Components/BootNavbar/Navbar";
import Footer from "./Components/Footers/Footer";

import Home from "./Pages/Home/Home";
import Facility from "./Pages/Facilities/Facility";
import Activity from "./Pages/Activities/Activity";
import Staffs from "./Pages/Staffs/Staffs";
import Fees from "./Pages/Fees/Fees";
import Aboutus from "./Pages/Aboutus/Aboutus";
import Alumni from "./Pages/Alumni/Alumni";
import Gallery from "./Pages/Gallery/Gallery";
import OnlineRegister from "./Pages/OnlineRegister/OnlineRegister";
import Curriculum from "./Pages/Curriculum/Curriculum";
import SchoolUniform from "./Pages/SchoolUniform/SchoolUniform";
import AcademicCalender from "./Pages/AcademicCalender/AcademicCalender";
import ContactUs from "./Pages/ContactUs/ContactUs";
import RegAdmission from "./Pages/RegAdmission/RegAdmission";
import ChooseUs from "./Pages/ChooseUs/ChooseUs";
import Downloadfile from "./Pages/Downloadfiles/Downloadfile";
import AdmForm from "./Pages/AdmForms/AdmForm";
import HolidayList from "./Pages/HolidayLists/HolidayList";

/* ADMIN */
import AdminLogin from "./admin/pages/AdminLogin";
import AdminLayout from "./admin/pages/AdminLayout";
import AdminContact from "./admin/pages/AdminContact";
import AdminAdmissions from "./admin/pages/AdminAdmissions";
import AdminAdmissionControl from "./admin/pages/AdminAdmissionControl";
import AdminStudents from "./admin/pages/AdminStudents";
import AdminSliders from "./admin/pages/AdminSliders";
import AdminGalleryManager from "./admin/pages/AdminGalleryManager";
import AdminActivityManager from "./admin/pages/AdminActivityManager";
import AdminAlumniManager from "./admin/pages/AdminAlumniManager";
import AdminCalender from "./admin/pages/AdminCalender";
import AdminStaffsManager from "./admin/pages/AdminStaffsManager";
import AdminNewsManager from "./admin/pages/AdminNewsManager";
import AdminChooseus from "./admin/pages/AdminChooseus";
import AdminFacilityManager from "./admin/pages/AdminFacilityManager";
import AdminVideoManager from "./admin/pages/AdminVideoManager";
import AdminDownloadManager from "./admin/pages/AdminDownloadManager";
import AdminFeesManager from "./admin/pages/AdminFeesManager";
import AdminHolidayList from "./admin/pages/AdminHolidayList";
import AdminFormsManager from "./admin/pages/AdminFormsManager";



/* ================= LAYOUT ================= */

const Layout = () => {

  const location = useLocation();

  const isAdminRoute =
    location.pathname.startsWith("/admin") ||
    location.pathname === "/login";

  useEffect(() => {
    if (!isAdminRoute) {
      const topbar = document.querySelector(".topbar");
      const navbar = document.querySelector(".custom-navbar");

      if (topbar && navbar) {
        document.body.style.paddingTop =
          topbar.offsetHeight + navbar.offsetHeight + "px";
      }
    } else {
      document.body.style.paddingTop = "0px";
    }
  }, [location,isAdminRoute]);

  return (
    <div className="app-wrapper">

      {!isAdminRoute && <Topbar />}
      {!isAdminRoute && <Navbar />}

      <div className="page-content">

        <Routes>

          {/* WEBSITE */}
          <Route path="/" element={<Home />} />
          <Route path="/facilities" element={<Facility />} />
          <Route path="/activities" element={<Activity />} />
          <Route path="/staffs" element={<Staffs />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/alumni" element={<Alumni />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/onlineregister" element={<OnlineRegister />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/schooluniform" element={<SchoolUniform />} />
          <Route path="/academiccalender" element={<AcademicCalender />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/regadmission" element={<RegAdmission />} />
          <Route path="/chooseus" element={<ChooseUs />} />
          <Route path="/downfilestype" element={<Downloadfile />} />
          <Route path="/admforms" element={<AdmForm />} />
          <Route path="/schoolholiday" element={<HolidayList />} />

          {/* LOGIN */}
          <Route path="/login" element={<AdminLogin />} />

          {/* ADMIN PANEL */}
          {/* <Route
            path="/admin"
            element={
              localStorage.getItem("token") ? (
                <AdminLayout />
              ) : (
                <Navigate to="/login" />
              )
            }
          > */}
          
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
            >
            <Route index element={<AdminContact />} />
            <Route path="contact" element={<AdminContact />} />
            <Route path="admissions" element={<AdminAdmissions />} />
            <Route path="onlineadmissioncontrol" element={<AdminAdmissionControl />} />
            <Route path="students" element={<AdminStudents />} />
            <Route path="sliders" element={<AdminSliders />} />
            <Route path="admingallery" element={<AdminGalleryManager/>} />
            <Route path="adminactivity" element={<AdminActivityManager />} />
            <Route path="adminalumni" element={<AdminAlumniManager />} />
            <Route path="admincalender" element={<AdminCalender />} />
            <Route path="adminstaffs" element={<AdminStaffsManager />} />
            <Route path="adminnews" element={<AdminNewsManager />} />
            <Route path="adminchooseus" element={<AdminChooseus /> } />
            <Route path="facility" element={<AdminFacilityManager />} />
            <Route path="videofilm" element={<AdminVideoManager /> } />
            <Route path="typedownfiles" element={<AdminDownloadManager />} />
            <Route path="feesrules" element={<AdminFeesManager />} />
            <Route path="listholiday" element={<AdminHolidayList />} />
            <Route path="printforms" element={<AdminFormsManager />} />
          </Route>

        </Routes>

      </div>

      {!isAdminRoute && <Footer />}

    </div>
  );
};

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;